import { useEffect, useState } from 'react'
import confetti from 'canvas-confetti'

const MILESTONES = {
  7: {
    headline: 'One week.',
    message: 'Seven days of showing up for yourself. You have built real momentum — the hardest part is behind you.',
    shareText: 'I just hit 7 days on Anchor — one week clean. Every day counts.',
  },
  30: {
    headline: 'One month.',
    message: 'Thirty days of choosing yourself. Real, lasting change is taking root. Keep going.',
    shareText: 'I just hit 30 days on Anchor — one month clean. Every day counts.',
  },
  90: {
    headline: 'Ninety days.',
    message: "Three months. You've rewired something real. This isn't a streak anymore — it's who you are.",
    shareText: 'I just hit 90 days on Anchor — three months clean. Every day counts.',
  },
}

const COLORS = ['#a78bfa', '#7c3aed', '#4ade80', '#c4b5fd', '#86efac', '#e9d5ff', '#ffffff']

function fireConfetti() {
  const burst = (opts) => confetti({ colors: COLORS, gravity: 0.85, ...opts })

  // Opening salvo — cannons from both sides
  burst({ particleCount: 80, angle: 60, spread: 65, origin: { x: 0, y: 0.65 } })
  burst({ particleCount: 80, angle: 120, spread: 65, origin: { x: 1, y: 0.65 } })

  // Centre burst
  setTimeout(() => {
    burst({ particleCount: 120, spread: 90, startVelocity: 30, origin: { x: 0.5, y: 0.5 } })
  }, 280)

  // Final wave from below
  setTimeout(() => {
    burst({ particleCount: 60, angle: 70, spread: 55, origin: { x: 0.1, y: 1 } })
    burst({ particleCount: 60, angle: 110, spread: 55, origin: { x: 0.9, y: 1 } })
  }, 560)
}

export default function MilestoneModal({ days, onClose }) {
  const [copied, setCopied] = useState(false)
  const milestone = MILESTONES[days]

  useEffect(() => {
    fireConfetti()
  }, [])

  function handleShare() {
    if (navigator.share) {
      navigator.share({ text: milestone.shareText }).catch(() => {})
    } else {
      navigator.clipboard.writeText(milestone.shareText).then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 2500)
      }).catch(() => {})
    }
  }

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <p style={styles.number}>{days}</p>
        <p style={styles.daysLabel}>days</p>
        <h2 style={styles.headline}>{milestone.headline}</h2>
        <p style={styles.message}>{milestone.message}</p>
        <button style={styles.shareBtn} onClick={handleShare}>
          {copied ? 'Copied to clipboard' : 'Share your achievement'}
        </button>
        <button style={styles.continueBtn} onClick={onClose}>
          Keep going
        </button>
      </div>
    </div>
  )
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(4, 4, 14, 0.97)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    zIndex: 300,
  },
  card: {
    width: '100%',
    maxWidth: 360,
    textAlign: 'center',
  },
  number: {
    color: '#ffffff',
    fontSize: 108,
    fontFamily: 'serif',
    lineHeight: 1,
    margin: '0 0 8px',
    textShadow:
      '0 0 30px rgba(167,139,250,0.8), 0 0 70px rgba(124,58,237,0.5), 0 0 120px rgba(124,58,237,0.25)',
  },
  daysLabel: {
    color: '#a78bfa',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 7,
    textTransform: 'uppercase',
    margin: '0 0 36px',
  },
  headline: {
    color: '#ffffff',
    fontFamily: 'serif',
    fontSize: 28,
    fontWeight: 400,
    margin: '0 0 16px',
  },
  message: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 15,
    lineHeight: 1.75,
    margin: '0 0 44px',
  },
  shareBtn: {
    width: '100%',
    padding: 16,
    background: 'linear-gradient(135deg, #7c3aed, #2563eb)',
    border: 'none',
    borderRadius: 14,
    color: '#fff',
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
    marginBottom: 12,
  },
  continueBtn: {
    width: '100%',
    padding: 14,
    background: 'none',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 14,
    color: 'rgba(255,255,255,0.4)',
    fontSize: 14,
    cursor: 'pointer',
  },
}
